import axios from 'axios';
import {getHeader} from './user_api';
import {REPORT_TEMPLATE_API_URL} from '../constants/api_routes';

export const getTemplateList = async () => {
    try {
        const response = await axios.get(`${REPORT_TEMPLATE_API_URL}/list`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status,
            success:false
        };
    }
};

export const getTemplateDetails = async (id) => {
    try {
        const response = await axios.get(`${REPORT_TEMPLATE_API_URL}/detail?report_template_id=${id}`, {headers: getHeader()});
        return {
            data:response.data,
            success:true
        }
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status,
            success:false
        };
    }
};

export const addOrUpdateTemplate =  async (action,formData) => {
    try {
        await axios.post(`${REPORT_TEMPLATE_API_URL}/${action}`,formData,{headers:getHeader()})
        return ({
            success:true,
            message:"Template successfully saved"
        }) ;
    } catch (e) {
        return {
            success:false,
            status:e.response.status,
            message: "Something went wrong. Try Again"
        }
    }
}




// WEBPACK FOOTER //
// ./src/data/report_template_api.js